import { render } from "./CadastroCliente.vue?vue&type=template&id=01398612"
import script from "./CadastroCliente.vue?vue&type=script&lang=js"
export * from "./CadastroCliente.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__